import { produce } from 'immer'
import {
  GET_PERSON_STATISTICS_INIT,
  GET_PERSON_STATISTICS_SUCCESS,
  GetPersonStatisticsActions,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.actions'
import {
  GET_ORGANIZATION_MEMBERS_FAILURE,
  GET_ORGANIZATION_MEMBERS_INIT,
  GET_ORGANIZATION_MEMBERS_SUCCESS,
  GetPeopleMembersActions,
} from 'src/app/PeopleMembers/redux/peopleMembers.actions'
import {
  REMOVE_USER_FROM_ORGANIZATION_FAILURE_ACTION,
  REMOVE_USER_FROM_ORGANIZATION_INIT_ACTION,
  REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION,
  RemoveUserFromOrganizationActions,
} from 'src/app/RemoveUserFromOrganization/redux/removeUserFromOrganization.actions'
import { peopleMembersRouteProps } from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface PeopleMembersState {
  ids: string[]
  loading: boolean
  complete: boolean
  totalItems?: number
  removing: boolean
  removeFailureTopLevelError?: string
  postingUserInvites: boolean
  postInvitesTopLevelError?: string
  postInvitesErrorDetailMap?: ErrorDetailMap<string>
  getOrgMembersTopLevelError?: string
  getOrgMembersErrorDetailMap?: ErrorDetailMap<string>
  page?: number
  numberOfPages?: number
}

export const initialState: PeopleMembersState = {
  ids: [],
  loading: false,
  complete: false,
  removing: false,
  postingUserInvites: false,
}

export type Actions =
  | GetPeopleMembersActions
  | RemoveUserFromOrganizationActions
  | GetPersonStatisticsActions

const CorePeopleMembersReducer = (
  state = initialState,
  action: Actions,
): PeopleMembersState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_PERSON_STATISTICS_INIT:
      case GET_ORGANIZATION_MEMBERS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_PERSON_STATISTICS_SUCCESS: {
        draft.loading = false
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_SUCCESS: {
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.users.map((user) => user.id)
            : [...draft.ids, ...action.payload.users.map((user) => user.id)]
        draft.loading = false
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.page = action.payload.pagination.page
        draft.numberOfPages = action.payload.pagination.numberOfPages
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_FAILURE: {
        const errors = parseBackendErrors(action.payload)

        draft.loading = false
        draft.complete = true
        draft.getOrgMembersTopLevelError = errors.topLevelError
        draft.getOrgMembersErrorDetailMap = errors.errorDetailMap
        return draft
      }

      case REMOVE_USER_FROM_ORGANIZATION_INIT_ACTION: {
        draft.removing = true
        return draft
      }

      case REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION: {
        draft.ids = draft.ids.filter((id) => id !== action.payload.user.id)
        draft.removing = false
        return draft
      }

      case REMOVE_USER_FROM_ORGANIZATION_FAILURE_ACTION: {
        const errors = parseBackendErrors(action.payload)

        draft.removeFailureTopLevelError = errors.topLevelError
        draft.removing = false
        return draft
      }
    }
  })
}

const PeopleMembersReducer = createBackgroundReducer(
  peopleMembersRouteProps,
  initialState,
  CorePeopleMembersReducer,
)

export default PeopleMembersReducer
